import { Link } from 'react-router-dom';

export function HowWePick() {
  return (
    <div className="max-w-3xl mx-auto py-12 px-4 sm:px-6">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-neutral-400 hover:text-white text-sm mb-8 transition-colors"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Back to search
      </Link>

      <h1 className="font-mono text-3xl sm:text-4xl font-bold text-white mb-8">
        How We Pick
      </h1>

      <div className="prose prose-invert prose-neutral max-w-none space-y-8">
        <p className="text-lg text-neutral-300 leading-relaxed">
          Every recommendation on this site is a single, opinionated choice. No "top 5" lists.
          No "best for most people." Just the one thing we'd actually buy.
        </p>

        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">Our Criteria</h2>

          <div className="space-y-6">
            <div className="border-l-2 border-orange-500 pl-4">
              <h3 className="font-bold text-white mb-2">1. It has to survive Scottish weather</h3>
              <p className="text-neutral-400">
                If it's not waterproof enough for a Highlands soaking, it doesn't make the cut.
                We assume the worst because Scottish weather delivers it.
              </p>
            </div>

            <div className="border-l-2 border-orange-500 pl-4">
              <h3 className="font-bold text-white mb-2">2. Value over hype</h3>
              <p className="text-neutral-400">
                Premium picks exist for people who want them, but we don't default to expensive.
                Budget picks are never "budget quality" — they're the best thing at that price point.
              </p>
            </div>

            <div className="border-l-2 border-orange-500 pl-4">
              <h3 className="font-bold text-white mb-2">3. Actually tested or extensively researched</h3>
              <p className="text-neutral-400">
                We've either used it personally or spent hours reading UKHillwalking forum threads
                so you don't have to.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">What We Don't Do</h2>
          <ul className="list-disc list-inside text-neutral-400 space-y-2">
            <li>Accept payment to feature products — no sponsorships influence picks</li>
            <li>Let affiliate commission rates influence picks</li>
            <li>Recommend gear we wouldn't trust ourselves</li>
          </ul>
        </section>

        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">The Tech</h2>
          <p className="text-neutral-400">
            Queries are parsed by Claude (Anthropic's AI) to understand what you're planning —
            location, duration, conditions, style preferences. Products are hand-curated by
            humans who've actually done these routes.
          </p>
          <p className="text-neutral-400 mt-4">
            We use weather data, route characteristics, and regional knowledge (midges in Scotland,
            altitude in the Andes) to make recommendations that actually fit your trip.
          </p>
        </section>

        <section className="border-t border-neutral-800 pt-8">
          <p className="text-neutral-500 text-sm">
            Questions? Email{' '}
            <a href="mailto:laurence@notfuckingabout.com" className="text-orange-500 hover:text-orange-400">
              laurence@notfuckingabout.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
